import { render, staticRenderFns } from "./human_child.vue?vue&type=template&id=08ab53a4&"
import script from "./human_child.vue?vue&type=script&lang=js&"
export * from "./human_child.vue?vue&type=script&lang=js&"
import style0 from "./human_child.vue?vue&type=style&index=0&id=08ab53a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports